'use client'

import { Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

import AssistantEmptySuggestions from '~/features/assistant/AssistantEmptySuggestions'

type EmptyStateProps = {
  /** Sends a starter question; without it the starters are not offered. */
  onSuggestion?: (text: string) => void
}

/** What a conversation with no messages shows: what to ask, how to tag an entity, and a few starter questions. */
export default function EmptyState({ onSuggestion }: EmptyStateProps) {
  const t = useTranslations('features.AssistantV2')
  const tBar = useTranslations('features.AssistantBar')
  return (
    <Stack spacing={1} data-testid="assistant-empty-state">
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {t('emptyState')}
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {tBar.rich('emptyStateMentionHint', { strong: (chunks) => <strong>{chunks}</strong> })}
      </Typography>
      {onSuggestion && <AssistantEmptySuggestions onSelect={onSuggestion} />}
    </Stack>
  )
}
